// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/filter-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/images/back-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav.filters-mobile {
  background-color: transparent;
  display: contents;
}

nav.filters-mobile button {
  float: right;
}

nav.filters-mobile button .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

#offcanvasNavbarFilters {
  margin-top: 7.25em;
  width: 101vw;
}

#offcanvasNavbarFilters ~ .offcanvas-backdrop {
  display: none;
}

.offcanvas-backdrop.show {
  display: none;
}

#offcanvasNavbarFilters .offcanvas-header {
  align-items: baseline;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

#offcanvasNavbarFilters .offcanvas-header h1 {
  font-weight: 700;
}

#offcanvasNavbarFilters .offcanvas-header button {
  margin-right: 0.6em;
}

#offcanvasNavbarFilters .offcanvas-header button.btn-close {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    center/1em auto no-repeat;
  opacity: 1;
  margin-left: 0;
}

span.filters-mobile-title {
  color: #a098ae;
  font-weight: 600;
  margin-bottom: 1em;
}

.filters-mobile-group {
  flex-direction: column;
}

.filters-mobile-group-fechas {
  flex-direction: row;
}

.filters-mobile-group span.filters-mobile-title {
  color: #a098ae;
  margin-top: 0.73em;
}

.filters-mobile-group-fechas span.filters-mobile-title {
  width: 100%;
}

.filters-mobile-group-fechas {
  border-radius: 0.5em;
  min-height: 3.5em;
  padding: 0.5em;
  position: relative;
}

.filters-mobile-group-fechas select {
  background-color: #ececec;
  border: none;
  color: #2b363b;
  height: 4.1em;
  margin-left: 2% !important;
  min-height: 3.5em;
  padding: 0.51em;
}

.filters-mobile-group-btn button {
  bottom: 0;
  left: 10%;
  position: fixed !important;
  width: 80%;
}

form.filters-mobile-form .form-check-input[type="checkbox"] ~ label {
  color: #c4c4c4;
  font-weight: 600;
}

form.filters-mobile-form .form-check-input[type="checkbox"]:checked ~ label {
  color: #2b363b;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/filtros/mobile/selectMobile.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oEAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;6BAC2B;EAC3B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["nav.filters-mobile {\n  background-color: transparent;\n  display: contents;\n}\n\nnav.filters-mobile button {\n  float: right;\n}\n\nnav.filters-mobile button .navbar-toggler-icon {\n  background-image: url(../../../../assets/images/filter-icon.svg) !important;\n}\n\n#offcanvasNavbarFilters {\n  margin-top: 7.25em;\n  width: 101vw;\n}\n\n#offcanvasNavbarFilters ~ .offcanvas-backdrop {\n  display: none;\n}\n\n.offcanvas-backdrop.show {\n  display: none;\n}\n\n#offcanvasNavbarFilters .offcanvas-header {\n  align-items: baseline;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}\n\n#offcanvasNavbarFilters .offcanvas-header h1 {\n  font-weight: 700;\n}\n\n#offcanvasNavbarFilters .offcanvas-header button {\n  margin-right: 0.6em;\n}\n\n#offcanvasNavbarFilters .offcanvas-header button.btn-close {\n  background: transparent url(\"../../../../assets/images/back-icon.svg\")\n    center/1em auto no-repeat;\n  opacity: 1;\n  margin-left: 0;\n}\n\nspan.filters-mobile-title {\n  color: #a098ae;\n  font-weight: 600;\n  margin-bottom: 1em;\n}\n\n.filters-mobile-group {\n  flex-direction: column;\n}\n\n.filters-mobile-group-fechas {\n  flex-direction: row;\n}\n\n.filters-mobile-group span.filters-mobile-title {\n  color: #a098ae;\n  margin-top: 0.73em;\n}\n\n.filters-mobile-group-fechas span.filters-mobile-title {\n  width: 100%;\n}\n\n.filters-mobile-group-fechas {\n  border-radius: 0.5em;\n  min-height: 3.5em;\n  padding: 0.5em;\n  position: relative;\n}\n\n.filters-mobile-group-fechas select {\n  background-color: #ececec;\n  border: none;\n  color: #2b363b;\n  height: 4.1em;\n  margin-left: 2% !important;\n  min-height: 3.5em;\n  padding: 0.51em;\n}\n\n.filters-mobile-group-btn button {\n  bottom: 0;\n  left: 10%;\n  position: fixed !important;\n  width: 80%;\n}\n\nform.filters-mobile-form .form-check-input[type=\"checkbox\"] ~ label {\n  color: #c4c4c4;\n  font-weight: 600;\n}\n\nform.filters-mobile-form .form-check-input[type=\"checkbox\"]:checked ~ label {\n  color: #2b363b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
